import { AuthInlineWidget } from '../components/AuthInlineWidget';

export function SignupPage() {
  return <AuthInlineWidget layout="page" defaultView="signup" />;
}
